import { formatReadableDate } from "utils/formatDate"
import { EmployeeLink } from "../EmployeeLink"

const FuelUsageInfoCell = ({ data = {} }) => {
  const { fuel_qty, mileage, remarks, uses_date, fuel_user } = data ?? {}

  const qty = parseFloat(fuel_qty ?? 0)

  return (
    <div className="text-dark">
      <div className="d-flex align-items-center mb-1">
        <i className="bx bx-gas-pump me-2 text-warning"></i>
        <span>
          Fuel Used: <strong>{qty > 0 ? `${qty.toFixed(2)} L` : "-"}</strong>
        </span>
      </div>

      <div className="mb-1">
        <i className="bx bx-user me-2 text-primary"></i>
        Used by:{" "}
        <EmployeeLink
          name={fuel_user?.name}
          username={fuel_user?.user?.username}
        />
      </div>

      <div className="mb-1">
        <i className="bx bx-calendar me-2 text-info"></i>
        Usage Date:{" "}
        <strong>{uses_date ? formatReadableDate(uses_date) : "-"}</strong>
      </div>

      {mileage != null && (
        <div className="mb-1">
          <i className="bx bx-tachometer me-2 text-success"></i>
          Mileage: <strong>{mileage.toLocaleString()} km</strong>
        </div>
      )}

      {remarks && (
        <div>
          <i className="bx bx-note me-2 text-muted"></i>
          Remarks: <strong>{remarks}</strong>
        </div>
      )}
    </div>
  )
}

export default FuelUsageInfoCell
